module.exports = __webpack_public_path__ + "be80d1aac16bd060f5fa546636be52e6.svg";